import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormikDialog } from './FormikDialog';

export const FormikCopyDialog = props => {
    const { dialogTitle, entityModel, ...rest } = props;
    const [title, setTitle] = useState(dialogTitle);

    useEffect(() => {
        if (!title && entityModel) {
            setTitle(<FormattedMessage id="entity.copy" values={{ entityModel: entityModel }} />);
        }
    }, []);

    return (
        <FormikDialog
            dialogTitle={title}
            {...rest}
        >
            {props.children}
        </FormikDialog>
    );
}